var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSosAlertTimelineWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4834_61463)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#ED0007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.582 19.3333V16H12.4154V19.3333H11.582ZM17.8945 16.8767L15.5291 14.5321L16.1237 13.9375L18.4683 16.3029L17.8945 16.8767ZM6.10286 16.8767L5.52911 16.3029L7.8737 13.9375L8.46828 14.5321L6.10286 16.8767ZM6.16536 6.83333V7.79479C6.16536 7.94438 6.21342 8.06729 6.30953 8.16354C6.40578 8.25965 6.5287 8.30771 6.67828 8.30771H17.3191C17.4687 8.30771 17.5916 8.25965 17.6879 8.16354C17.784 8.06729 17.832 7.94438 17.832 7.79479V6.83333H6.16536ZM8.26786 9.14104L8.67828 10.2787C8.72092 10.3857 8.78502 10.4685 8.87057 10.5273C8.95599 10.586 9.0521 10.6154 9.15891 10.6154H14.8385C14.9453 10.6154 15.0414 10.586 15.1268 10.5273C15.2124 10.4685 15.2765 10.3857 15.3191 10.2787L15.7295 9.14104H8.26786ZM9.15891 11.4487C8.87266 11.4487 8.61307 11.3678 8.38016 11.2058C8.14724 11.044 7.98057 10.8269 7.88016 10.5546L7.38328 9.14104H6.67828C6.30536 9.14104 5.98773 9.00986 5.72536 8.7475C5.46314 8.48528 5.33203 8.16771 5.33203 7.79479V6H18.6654V7.79479C18.6654 8.16771 18.5343 8.48528 18.272 8.7475C18.0097 9.00986 17.692 9.14104 17.3191 9.14104H16.6141L16.0564 10.5737C15.9528 10.829 15.7888 11.0387 15.5643 11.2027C15.34 11.3667 15.0863 11.4487 14.8033 11.4487H9.15891Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4834_61463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosAlertTimelineWhite);
export default __webpack_public_path__ + "static/media/sos-alert-timeline-white.562ea81b469619bab179e8786fd6cd6d.svg";
export { ForwardRef as ReactComponent };